import React from 'react';
import { View } from 'react-native';
import { Text } from '@shared/components/text';
import Icon from '@shared/components/md-design-system/Icon/Icon';
import { colorPalette } from '@shared/config/colorsConfig';
import { dynamicTranslations } from '@shared/utils/dynamicTranslation';
import { TTeleassistanceAppointment } from 'app/_modules/pathways';
import { getFormattedTimestamp } from '@shared/utils/date';
import { getDoctorTitle } from '@shared/utils/doctor';

interface Props {
    appointment: TTeleassistanceAppointment;
    reasonLabel: string;
}

export const TeleassistanceScheduledContent: React.FC<Props> = ({ appointment, reasonLabel }) => {
    const { t } = dynamicTranslations();
    const s = 'teleassistance.card';

    const doctorTitle = appointment.doctor ? getDoctorTitle(appointment.doctor.title, t) : '';
    const doctorName = appointment.doctor ? `${doctorTitle} ${appointment.doctor.lastName}` : '';

    return (
        <>
            <View className="flex-row items-center gap-3 mb-2">
                <View className="w-8 h-8 rounded-full bg-primary-100 justify-center items-center">
                    <Icon name="calendar" size={16} color={colorPalette.primary[700]} />
                </View>
                <Text className="font-semibold text-base">{t(`${s}.scheduledTitle`)}</Text>
            </View>
            <Text className="text-sm text-gray-700 mb-1">
                {t(`${s}.scheduledDescription`, { reason: reasonLabel, doctor: doctorName })}
            </Text>
            {appointment.date && appointment.time && (
                <Text className="text-sm text-gray-500">
                    {getFormattedTimestamp(`${appointment.date}T${appointment.time}`)}
                </Text>
            )}
        </>
    );
};
